import UtilityProvince from "../../domain/Util/UtilityProvince";
import BasicAuthGenerator from "../../utils/BasicAuthGenerator";
import RawWsService from "../RawWsService";
import UserSessionService from "../UserSessionService";

const ENDPOINT_BASE = "/utility/province";

export default class UtilityProvinceService {

    static retrieveProvinceList() {

        let endpoint = ENDPOINT_BASE;

        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();

        let headers = {
            "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"])
        };

        return RawWsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {

                let results = [];

                response.body.forEach(province => {
                    results.push(new UtilityProvince(province))
                });

                return results;

            },
            response => {

                return response;

            }
        )

    }

}
